import { render } from "./BuddySelectBar.vue?vue&type=template&id=3101bcf0&scoped=true"
import script from "./BuddySelectBar.vue?vue&type=script&lang=js"
export * from "./BuddySelectBar.vue?vue&type=script&lang=js"

import "./BuddySelectBar.vue?vue&type=style&index=0&id=3101bcf0&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3101bcf0"]])

export default __exports__